import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { siteInfo, navItems } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-neutral-200 mt-20">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold tracking-[0.15em] text-neutral-900 mb-2">COMPUTHEER</h3>
            <p className="text-[10px] tracking-[0.25em] text-neutral-600 mb-6">
              COMPUTER SERVICE EN REPARATIES
            </p>
            <p className="text-neutral-600 leading-relaxed max-w-md">
              Uw betrouwbare partner voor computer reparaties, ICT-beheer, netwerk oplossingen en
              technische ondersteuning. Snel, eerlijk en persoonlijk.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase text-neutral-900 mb-4">
              Snel naar
            </h4>
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-neutral-600 hover:text-neutral-900 transition-colors text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/contact" className="text-neutral-600 hover:text-neutral-900 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase text-neutral-900 mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2 text-neutral-600">
                <MapPin size={14} className="mt-1 flex-shrink-0" />
                <span>
                  {siteInfo.address.street}
                  <br />
                  {siteInfo.address.zip}
                </span>
              </li>
              <li>
                <a href={`tel:${siteInfo.phoneRaw}`} className="flex items-center gap-2 text-neutral-600 hover:text-neutral-900">
                  <Phone size={14} />
                  {siteInfo.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${siteInfo.email}`} className="flex items-center gap-2 text-neutral-600 hover:text-neutral-900">
                  <Mail size={14} />
                  {siteInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-neutral-900 text-neutral-400 text-center text-sm py-5">
        ©{new Date().getFullYear()} Computheer. KVK: {siteInfo.kvk} · BTW: {siteInfo.btw}
      </div>
    </footer>
  );
};

export default Footer;
